function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Path");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Archive-Move-2",
  transform: "translate(-7.000000, -5.000000)",
  fill: "#002645"
}, React.createElement("path", {
  d: "M9.03160772,37.4627778 L15.2745873,36.361972 C19.5064291,43.085557 28.1803301,45.7672188 35.5683148,42.322145 C43.5769543,38.5876551 47.0418372,29.0679677 43.3073472,21.0593282 C39.5728573,13.0506887 30.05317,9.58580588 22.0445305,13.3202958 C20.7505529,13.9236875 19.5751935,14.678106 18.5296535,15.5527759 L22.3360859,19.145455 L7.11764451,24.6487122 L10.4279914,7.90606944 L14.1431334,11.4125846 C15.7104563,10.0130436 17.5063381,8.81622215 19.5088209,7.88244909 C30.5207002,2.74752543 43.6102703,7.51173932 48.745194,18.5236186 C53.8801176,29.535498 49.1159037,42.6250681 38.1040244,47.7599917 C27.2074837,52.8411321 14.276548,48.2294165 9.03160772,37.4627778 Z",
  id: "Path"
})));

var SvgRestore = function SvgRestore(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "44px",
    height: "45px",
    viewBox: "0 0 44 45",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRestore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/restore.a2e27661.svg";
export { ForwardRef as ReactComponent };